<template>
  <el-main class="Content Content_centered">
    <app-panel :class="$style.panel" main v-loading.fullscreen.lock="loading">
      <h1 slot="title" class="AppTitle">
        E-Mail überprüfen
      </h1>
    </app-panel>
  </el-main>
</template>

<script>
import AppPanel from "../../components/common/layout/AppPanel";
import { getErrorMsg, showError } from "../../util/validation";
import { CONFIRM_ACCOUNT_MUTATION } from "~/graphql/mutations";

export default {
  components: { AppPanel },
  validate({ query }) {
    const { confirmation_token } = query;
    return !!confirmation_token;
  },
  data() {
    return {
      loading: true,
    };
  },
  mounted() {
    this.checkToken();
  },
  methods: {
    checkToken() {
      this.loading = true;
      const { confirmation_token } = this.$route.query;
      return this.$apollo
        .mutate({
          // Query
          mutation: CONFIRM_ACCOUNT_MUTATION,
          // Parameters
          variables: {
            confirmationToken: confirmation_token,
          },
        })
        .then(({ data: { confirmAccount } }) => {
          // Result
          console.log(confirmAccount);
          if (!confirmAccount) {
            const change = false;
            return this.$msgbox({
              type: "success",
              title: change
                ? "E-Mail-Adresse geändert"
                : "E-Mail-Adresse überprüft",
              message: change
                ? `Wir haben erfolgreich Ihre E-Mail-Adresse zu ${r.result.email} geändert.`
                : "Ihre Registrierung ist nun abgeschlossen",
            })
              .catch(() => false)
              .finally(() => {
                return this.$router.replace({ name: "login" });
              });
          } else {
            return this.$msgbox({
              type: "warning",
              title: "Fehler",
              message: getErrorMsg(
                confirmAccount.key,
                confirmAccount.details,
                confirmAccount.messages
              ),
            })
              .catch(() => false)
              .finally(() => {
                return this.$router.replace({ name: "login" });
              });
          }
        })
        .catch((error) => {
          // Error
          console.error(error);
          return showError(error);
        });
    },
    login() {
      this.$router.push({ name: "login" });
    },
  },
  head() {
    return {
      title: "E-Mail überprüfen",
    };
  },
};
</script>

<style lang="module.scss" module>
.panel {
  width: 400px;
  max-width: calc(100vw - 40px);
}
</style>
